<template>
  <!-- 银行账户 -->
  <div class="transferList">
    <el-row class="middle">
      <el-button size="medium" @click="creatNewAccount()">创建账户</el-button>
    </el-row>
    <div style="padding: 20px 0; background:white; border-radius:3px">
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" stripe border>
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="DEPOSIT_BANK" label="开户银行" min-width="80"></el-table-column>
            <el-table-column prop="ACCOUNT_NUM" label="账户号码" min-width="80"></el-table-column>
            <el-table-column label="账户类型" min-width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.ACCOUNT_TYPE === 1">基本存款账户</span>
                <span v-if="scope.row.ACCOUNT_TYPE === 2">一般存款账户</span>
                <span v-if="scope.row.ACCOUNT_TYPE === 3">临时存款账户</span>
                <span v-if="scope.row.ACCOUNT_TYPE === 4">专用存款账户</span>
              </template>
            </el-table-column>
            <el-table-column prop="BALANCE" label="账户余额" min-width="80"></el-table-column>
            <el-table-column prop="UPDATE_TIME" label="更新时间" min-width="50"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-view" size="small" @click="update(scope.row)">更新余额</el-button>
                <el-button type="text" icon="el-icon-view" size="small" @click="detail(scope.row)">详情</el-button>
                <el-button type="text" icon="el-icon-view" size="small" style="color:red" @click="change(scope.row)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <!-- 新建账户模态框 -->
    <el-dialog title="新建账户" :visible.sync="creatAccountVisible" width="30%" center>
      <el-form>
        <el-form-item label="账户分类：" :label-width="formLableWidth">
          <el-select size="small" filterable v-model="ACCOUNT_TYPE" placeholder="请选择" :clearable="true">
            <el-option v-for="item in servicetype" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开户银行：" :label-width="formLableWidth">
          <el-input v-model="DEPOSIT_BANK" size="small"></el-input>
        </el-form-item>
        <el-form-item label="账户号码：" :label-width="formLableWidth">
          <el-input v-model="ACCOUNT_NUM" size="small"></el-input>
        </el-form-item>
        <el-form-item label="账户余额：" :label-width="formLableWidth">
          <el-input v-model="BALANCE" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="creatAccountVisible = false">取消</el-button>
        <el-button type="primary" @click="subAccount()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 更新余额模态框 -->
    <el-dialog title="余额更新" :visible.sync="updateVisible" width="30%" center>
      <el-form>
        <el-form-item label="开户银行：" :label-width="formLableWidth">
          <span>{{ updateForm.DEPOSIT_BANK }}</span>
        </el-form-item>
        <el-form-item label="账户号码：" :label-width="formLableWidth">
          <span>{{ updateForm.ACCOUNT_NUM }}</span>
        </el-form-item>
        <el-form-item label="账户余额：" :label-width="formLableWidth">
          <el-input v-model="updateForm.BALANCE" size="small" style="width:216px"></el-input>
        </el-form-item>
        <el-form-item label="上报日期：" :label-width="formLableWidth">
          <el-date-picker v-model="upTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateVisible = false">取消</el-button>
        <el-button type="primary" @click="subUpdate()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 删除模态框 -->
    <el-dialog title="删除确认" :visible.sync="changeVisible" width="30%" center>
      <span>删除将会连同该账号所有流水一起删除，请确认！！！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeVisible = false">取消</el-button>
        <el-button type="primary" @click="subChange()">确定</el-button>
      </span>
    </el-dialog>
    <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
      layout="total,prev, pager, next, jumper" :total="total_count" style="float:right;margin-top: 10px">
    </el-pagination>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      formLableWidth: '120px',
      COUNTS: [],
      servicetype: [
        {
          label: '基本存款账户',
          value: '1',
        },
        {
          label: '一般存款账户',
          value: '2',
        },
        {
          label: '临时存款账户',
          value: '3',
        },
        {
          label: '专用存款账户',
          value: '4',
        },
      ],
      upTime: new Date(), // 上报日期
      pageSize: 10,
      currentPage: 1,
      total_count: 0,
      tableData: [],
      // 新建开户
      creatAccountVisible: false,
      DEPOSIT_BANK: '',
      ACCOUNT_NUM: '',
      ACCOUNT_TYPE: '',
      BALANCE: '',
      // 更新余额数据
      updateForm: {},
      updateVisible: false,
      // 修改所需数据
      changeVisible: false,
      changeForm: {},
      releteCompanyId: 0,
    };
  },
  computed: {
    ADJUSTDOCUMENTLIST_DATA_CONDITION() {
      return this.$store.state.ADJUSTDOCUMENTLIST_DATA_CONDITION;
    },
  },
  methods: {
    // 新建账户
    creatNewAccount() {
      this.creatAccountVisible = true;
    },
    // 新建账户提交
    subAccount() {
      if (this.releteCompanyId == 0) {
        this.$message.show({ text: '您尚未关联三产公司！请联系管理员处理', type: 'warning' });
        this.creatAccountVisible = false;
        return;
      }
      if (!this.DEPOSIT_BANK || !this.ACCOUNT_NUM || !this.ACCOUNT_TYPE || !this.BALANCE) {
        this.$message.show({ text: '请将信息填写完整', type: 'warning' });
        return;
      }
      const regu = '^[ ]+$';
      const re = new RegExp(regu);
      // eslint-disable-next-line prefer-regex-literals
      const reg = new RegExp('^[0-9]+([.]{1}[0-9]{0,2}){0,1}$');
      if (re.test(this.BALANCE)) {
        this.$message.show({ text: '余额格式错误，请重新输入！', type: 'warning' });
        return;
      }
      if (!reg.test(this.BALANCE)) {
        this.$message.show({ text: '余额格式错误，请重新输入！', type: 'warning' });
        return;
      }
      if (!this.ACCOUNT_NUM.replace(/[^\d]/g, '')) {
        this.$message.show({ text: '账户号码格式不正确，请输入', type: 'warning' });
        return;
      }
      if (this.ACCOUNT_NUM.length > 50) {
        this.$message.show({ text: '账户号码超出范围！请重新输入', type: 'warning' });
        return;
      }
      if (!this.BALANCE.replace(/[^\d]/g, '')) {
        this.$message.show({ text: '账户余额输入格式错误，请重新输入', type: 'warning' });
        return;
      }
      if (Number(this.BALANCE) > 100000000000) {
        this.$message.show({ text: '余额超出指定范围，请重新输入！', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '15063',
        OTYPE: 1,
        TC_ID: this.releteCompanyId,
        DEPOSIT_BANK: this.DEPOSIT_BANK,
        ACCOUNT_NUM: this.ACCOUNT_NUM,
        ACCOUNT_TYPE: this.ACCOUNT_TYPE,
        BALANCE: this.BALANCE,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '创建成功', type: 'success' });
        this.creatAccountVisible = false;
        this.currentPage = 1;
        this.queryDocument();
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    // 点击修改
    change(row) {
      this.changeForm = row;
      this.changeVisible = true;
    },
    // 修改确认
    subChange() {
      const params = {
        SERVICE_ID: '15063',
        OTYPE: 2,
        // ACCOUNT_ID: this.changeForm.ACCOUNT_ID,
        // DEPOSIT_BANK : this.changeForm.DEPOSIT_BANK,
        ACCOUNT_NUM: this.changeForm.ACCOUNT_NUM,
        // ACCOUNT_TYPE : this.changeForm.ACCOUNT_TYPE
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.changeVisible = false;
        this.queryDocument();
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    search() {
      this.currentPage = 1;
      this.queryDocument();
    },
    clear() {
      this.COUNTS = [];
      this.selectedOptions = [];
      this.searchForm = {};
      this.queryProject();
    },
    // 跳转到详情
    detail(row) {
      this.$router.push({
        path: '/bankAccountDetail/',
        params: { id: row.ACCOUNT_NUM },
      });
      sessionStorage.setItem('ACCOUNT_NUM', row.ACCOUNT_NUM);
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryDocument();
    },
    showStatusLable(index) {
      return this.STATUS_LIST[index];
    },
    // 更新余额
    update(row) {
      this.updateForm = row;
      this.updateVisible = true;
    },
    // 更新余额确认
    subUpdate() {
      // eslint-disable-next-line prefer-regex-literals
      const reg = new RegExp('^[0-9]+([.]{1}[0-9]{0,2}){0,1}$');
      if (!this.updateForm.BALANCE.replace(/[^\d]/g, '')) {
        this.$message.show({ text: '余额输入格式错误，请重新输入', type: 'warning' });
        return;
      }
      if (!this.updateForm.BALANCE) {
        this.$message.show({ text: '请输入余额！', type: 'warning' });
        return;
      }
      if (!reg.test(this.updateForm.BALANCE)) {
        this.$message.show({ text: '余额格式错误，请重新输入！', type: 'warning' });
        return;
      }
      if (Number(this.updateForm.BALANCE) > 100000000000) {
        this.$message.show({ text: '余额超出指定范围，请重新输入！', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '15063',
        OTYPE: 3,
        ACCOUNT_NUM: this.updateForm.ACCOUNT_NUM,
        BALANCE: this.updateForm.BALANCE,
        REPORT_DATE: date(this.upTime, '%F'),
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '更新成功', type: 'success' });
        this.updateVisible = false;
        this.queryDocument();
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    queryTC_ID() {
      const params = {
        SERVICE_ID: '15063',
        OTYPE: 7,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.releteCompanyId = result[0].TC_ID;
        this.queryDocument();
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    queryDocument() {
      const params = {
        SERVICE_ID: '15063',
        OTYPE: 6,
        TC_ID: this.releteCompanyId,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      http.post(params).then((result) => {
        if (result[0].LIST.length == 0) {
          if (this.currentPage != 0) {
            this.currentPage -= 1;
            this.queryDocument();
          } else {
            this.$message.show({ text: '暂无数据', type: 'warning' });
            this.tableData = [];
            this.total_count = 0;
          }
        }
        if (result[0].LIST) {
          this.tableData = result[0].LIST;
          this.total_count = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.total_count = 0;
        }
        if (this.searchForm) {
          this.$store.dispatch('SET_ADJUSTDOCUMENTLIST_DATA_CONDITION', {
            CONDITION: this.searchForm,
            DATA: this.tableData,
            TOTAL_COUNT: this.total_count,
          });
        }
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
  },
  created() {
    // if ('CONDITION' in this.ADJUSTDOCUMENTLIST_DATA_CONDITION && 'DATA' in this.ADJUSTDOCUMENTLIST_DATA_CONDITION && 'TOTAL_COUNT' in this.ADJUSTDOCUMENTLIST_DATA_CONDITION) {
    //   this.tableData = this.ADJUSTDOCUMENTLIST_DATA_CONDITION.DATA
    //   this.searchForm = this.ADJUSTDOCUMENTLIST_DATA_CONDITION.CONDITION
    //   this.total_count = this.ADJUSTDOCUMENTLIST_DATA_CONDITION.TOTAL_COUNT
    // }
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(sessionStorage.getItem('SMP_PAGE_COUNT')) ? Number(sessionStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.searchForm = {};
    this.tableData = [];
    this.COUNTS = [];
    this.queryTC_ID();
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/financeCenter/bankAccount.vue